import { render, staticRenderFns } from "./MakeBillPaidModal.vue?vue&type=template&id=2b5302e4&scoped=true&"
import script from "./MakeBillPaidModal.vue?vue&type=script&lang=js&"
export * from "./MakeBillPaidModal.vue?vue&type=script&lang=js&"
import style0 from "./MakeBillPaidModal.vue?vue&type=style&index=0&id=2b5302e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5302e4",
  null
  
)

export default component.exports